import React from "react";
import { Loader2, ArrowRight, ArrowLeft } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { IDR } from "@/lib/format";

/** Fixed bottom bar: live counters plus save / back / continue / submit. */
export const SelectionBar = ({
  data, baseIds, extras, prints, extraCost, step, steps, busy, canContinue,
  onSave, onBack, onNext, onSubmit,
}) => {
  const { t } = useI18n();

  return (
    <div className="fixed bottom-safe left-1/2 -translate-x-1/2 z-40 w-[calc(100%-1.5rem)] sm:w-auto">
      <div className="glass border border-[#2A2A2A] px-4 sm:px-6 py-3.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-7">
        <div aria-live="polite" className="font-mono-accent text-[10px] sm:text-[11px] tracking-[0.14em] uppercase text-center sm:text-left">
          <span data-testid="edit-counter">
            <span className="text-[#D4AF37]">{baseIds.length}</span>/{data.edit_quota} {t("edits")}
          </span>
          {extras.length > 0 && (
            <span data-testid="extra-counter" className="ml-3 text-[#D4AF37]">+{extras.length} {t("extra")}</span>
          )}
          {prints.length > 0 && (
            <span data-testid="print-counter" className="ml-3">{prints.length} {t("prints")}</span>
          )}
          {extraCost > 0 && (
            <span data-testid="running-total" className="ml-3 text-[#D4AF37]">{IDR(extraCost)}</span>
          )}
        </div>
        <div className="flex items-stretch gap-2.5">
          <button data-testid="save-draft-btn" onClick={onSave} disabled={busy}
            className="text-[10px] tracking-[0.18em] uppercase border border-[#2A2A2A] px-4 min-h-[48px] sm:min-h-[44px] hover:border-[#D4AF37] transition-colors disabled:opacity-50">
            {t("save")}
          </button>
          {step > 0 && (
            <button data-testid="step-back-btn" onClick={onBack} aria-label={t("back")}
              className="inline-flex items-center justify-center gap-1.5 text-[10px] tracking-[0.18em] uppercase border border-[#2A2A2A] px-4 min-h-[48px] sm:min-h-[44px] hover:border-[#D4AF37] transition-colors">
              <ArrowLeft size={14} /> <span className="hidden sm:inline">{t("back")}</span>
            </button>
          )}
          {step < steps.length - 1 ? (
            <button data-testid="step-next-btn" disabled={!canContinue || busy} onClick={onNext}
              className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-black px-6 min-h-[48px] sm:min-h-[44px] text-[10px] tracking-[0.18em] uppercase font-semibold hover:bg-[#E6C96B] transition-colors disabled:opacity-40">
              {t("continue")} <ArrowRight size={14} />
            </button>
          ) : (
            <button data-testid="submit-selection-btn" onClick={onSubmit} disabled={busy}
              className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-black px-6 min-h-[48px] sm:min-h-[44px] text-[10px] tracking-[0.18em] uppercase font-semibold hover:bg-[#E6C96B] transition-colors disabled:opacity-50">
              {busy && <Loader2 size={12} className="animate-spin" />} {t("submit_selection")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
